<div class="settings-page">
    <div class="settings-page__content">
        <div class="settings-card">
            <div class="settings-card__header">
                <img src="/assets/images/Group 24.svg" alt="" />
                <div class="settings-card__header-headline">
                    <h2>Bine ați venit!</h2>
                    <h4>Setările Dumneavoastră Indoc</h4>
                </div>
            </div>
        </div>
    </div>

    <div class="content-box">
        <div class="settings-page-container">
            <mat-button-toggle-group [value]="selectedComponent" (change)="onChange($event)" class="settings-page_menu">
                <mat-button-toggle [value]="option" class="settings-page_menu-item"
                    *ngFor="let option of componentKeys">
                    <div style="text-align: left;">
                        {{ option }}
                    </div>
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <div class="settings-page__content">
            <ng-container *ngIf="selectedComponent === SettingsOption.GENERAL">
                <app-general></app-general>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.DOCUMENT_ACCESS_TYPES">
                <app-document-access-types></app-document-access-types>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.PRIORITIES">
                <app-priorities></app-priorities>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.STATUSES">
                <app-status></app-status>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.DOCUMENT_TYPES">
                <app-document-types></app-document-types>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.SERIES_DOCUMENTS">
                <app-series-documents></app-series-documents>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.SOURCES_DOCUMENTS">
                <app-sources-documents></app-sources-documents>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.PERSONS_ENTITY_TYPES">
                <app-persons-entity-types></app-persons-entity-types>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.DOCUMENT_FINALIZATION_TYPES">
                <app-document-finalization-types></app-document-finalization-types>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.TEMPLATE_DOCUMENTE">
                <app-document-template></app-document-template>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.CATEGORII_TEMPLATE">
                <app-template-categories></app-template-categories>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.NON_WORKING_DAYS">
                <app-non-working-days></app-non-working-days>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.DOCUMENT_TYPES_FILES">
                <app-document-types-files></app-document-types-files>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.REDIRECTION_ADDRESSES">
                <app-redirection-addresses></app-redirection-addresses>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.DIRECTIE_SERII">
                <app-directie-serii></app-directie-serii>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.STATUSURI_POSTA">
                <app-status-posta></app-status-posta>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.OFICII_POSTALE">
                <app-oficiu-postal></app-oficiu-postal>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.EMAILS_BLACKLIST">
                <app-emails-blacklist></app-emails-blacklist>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.OPERATORI">
                <app-operatori></app-operatori>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsOption.HEADER_FOOTER">
                <app-document-header-footer></app-document-header-footer>
            </ng-container>
            <div class="row" *ngIf="selectedComponent == null">
                <div class="col-sm-12 py-5">
                    <div class="row h-100 justify-content-center align-items-center">
                        <div class="col-12 text-center">
                            <div class="py-3">
                                <p class="mb-0">Selectați o secțiune</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>